import React, { useEffect, useState } from 'react'
import { Dimensions, Image } from 'react-native'
import { PinchView } from 'react-native-pinch-view'
import { placeholderGeneral } from '../Constants' // TODO: este placeholder debe venir de assets del repositorio
import styles from './ImageWithZoomStyles'
import { searchFile } from './ImageWIthZoom'
import { getImageSize, validateConnectionNetwork } from '../../../utils/functions.utils'
const deviceWidth = Dimensions.get('window').width

// export const ImageWithZoomContain = ({ uri, path }) => {
//     console.log("🚀 ~ ImageWithZoomContain ~ path:", path)
//     const [imageHeight, setImageHeight] = useState(0)
//     const [image, setImage] = useState(uri)

//     useEffect(() => {
//         if (uri) {
//             Image.getSize(
//                 uri,
//                 (width, height) => {
//                     const ratio = height / width
//                     const calculatedHeight = deviceWidth * ratio
//                     setImageHeight(calculatedHeight)
//                 },
//                 (error) => {
//                     console.error('Error al obtener el tamaño de la imagen: ', error)
//                 },
//             )
//         }
//     }, [uri])
//     return (
//         <PinchView>
//             <Image
//                 source={{ uri: image }}
//                 style={[
//                     styles.imageWithZoomContain,
//                     {
//                         height: imageHeight,
//                     },
//                 ]}
//                 resizeMode='contain'
//             />
//         </PinchView>
//     )
// }

// @Fixme - This is the final version of the snippet for local images
export const ImageWithZoomContain = ({ uri, path }) => {
    const [imageHeight, setImageHeight] = useState(500)
    const [image, setImage] = useState({ uri: uri })

    useEffect(() => {
        if (!uri) {
            setImage({ uri: placeholderGeneral })
            return
        }
        if (!path || path.trim() === '') {
            setImage(uri)
            return
        }
        const fetchImage = async () => {
            try {
                let image = await searchFile(uri, path)

                const isConnection = await validateConnectionNetwork()

                if (image.includes('http') && isConnection) {
                    Image.getSize(image, (width, height) => {
                        const ratio = height / width
                        const calculatedHeight = deviceWidth * ratio
                        setImageHeight(calculatedHeight)
                    })
                    setImage({ uri: image })
                } else {
                    const { height, width } = await getImageSize(image)
                    if (height && width) {
                        const ratio = height / width
                        const calculatedHeight = deviceWidth * ratio
                        setImageHeight(calculatedHeight)

                        setImage({ uri: image })
                    } else {
                        setImageHeight(deviceWidth)
                        setImage({ uri: image })
                    }
                }
            } catch (error) {
                console.error('🚀 ~ fetchImage ~ error', error)
                setImageHeight(deviceWidth)
                setImage({ uri: placeholderGeneral }) // Usa una imagen de marcador de posición en caso de error
            }
        }
        fetchImage()
    }, [])

    // useEffect(() => {
    //     if (image) {
    //         let newImage = image.uri ? image.uri : image
    //         Image.getSize(
    //             newImage,
    //             (width, height) => {
    //                 const ratio = height / width
    //                 const calculatedHeight = deviceWidth * ratio
    //                 setImageHeight(calculatedHeight)
    //             },
    //             (error) => {
    //                 console.error('Error al obtener el tamaño de la imagen: ', error)
    //             },
    //         )
    //     }
    // }, [image])
    return (
        <PinchView>
            <Image
                source={image}
                style={[
                    styles.imageWithZoomContain,
                    {
                        height: imageHeight,
                    },
                ]}
                resizeMode='contain'
            />
        </PinchView>
    )
}
